(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("prop-types"));
	else if(typeof define === 'function' && define.amd)
		define([, ], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("react"), require("prop-types")) : factory(root[undefined], root[undefined]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, (__WEBPACK_EXTERNAL_MODULE__5225__, __WEBPACK_EXTERNAL_MODULE__6073__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ 9008:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5225);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6073);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
var _excluded = ["name", "size", "color", "additionalCSS"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }




var Icon = function Icon(_ref) {
  var name = _ref.name,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "0.75rem" : _ref$size,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? "" : _ref$color,
      _ref$additionalCSS = _ref.additionalCSS,
      additionalCSS = _ref$additionalCSS === void 0 ? "" : _ref$additionalCSS,
      additionalAttributes = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("svg", _extends({
    className: "".concat(color, " ").concat(additionalCSS),
    style: {
      width: size,
      height: size
    }
  }, additionalAttributes), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default().createElement("use", {
    xlinkHref: "#sprite-".concat(name)
  }));
};

Icon.propTypes = {
  name: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string.isRequired),
  size: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  color: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string),
  additionalCSS: (prop_types__WEBPACK_IMPORTED_MODULE_1___default().string)
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (Icon);

/***/ }),

/***/ 6073:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__6073__;

/***/ }),

/***/ 5225:
/***/ ((module) => {

module.exports = __WEBPACK_EXTERNAL_MODULE__5225__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
(() => {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ Footer)
});

// EXTERNAL MODULE: external {"commonjs":"react","commonjs2":"react"}
var external_commonjs_react_commonjs2_react_ = __webpack_require__(5225);
var external_commonjs_react_commonjs2_react_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_react_commonjs2_react_);
// EXTERNAL MODULE: external {"commonjs":"prop-types","commonjs2":"prop-types"}
var external_commonjs_prop_types_commonjs2_prop_types_ = __webpack_require__(6073);
var external_commonjs_prop_types_commonjs2_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_prop_types_commonjs2_prop_types_);
// EXTERNAL MODULE: ./src/core/Icon/component.jsx
var component = __webpack_require__(9008);
;// CONCATENATED MODULE: ./src/core/url-base.js
var DEFAULT_URL_BASE = "";

var absUrl = function absUrl(path) {
  var urlBase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_URL_BASE;
  return "".concat(urlBase).concat(path);
};

/* harmony default export */ const url_base = (absUrl);
;// CONCATENATED MODULE: ./src/core/Footer/component.jsx




function Footer(_ref) {
  var paths = _ref.paths,
      urlBase = _ref.urlBase;

  var absUrl = function absUrl(path) {
    return url_base(path, urlBase);
  };

  return /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("footer", {
    className: "bg-light-grey font-sans antialiased leading-normal",
    "data-id": "footer"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "max-w-screen-xl mx-auto py-32 sm:py-40 md:py-64 ui-grid-gap ui-grid-px grid grid-cols-6"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full md:col-span-2"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-row p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("img", {
    className: "mr-24 -mt-16",
    src: paths.ablyStack,
    alt: "Ably homepage"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("h2", {
    className: "ui-text-overline2 col-span-full"
  }, "The Ably Platform")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "md:col-span-4 md:w-3/4 xs:w-3/5 w-full"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-text-p3 font-bold py-16 p-menu-row-snug"
  }, "Easily power any realtime experience in your application via a simple API that handles everything realtime.")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", {
    className: "grid grid-cols-1"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/channels"),
    className: "ui-footer-menu-row-link"
  }, "Pub/sub messaging")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/push-notifications"),
    className: "ui-footer-menu-row-link"
  }, "Push notifications")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/integrations"),
    className: "ui-footer-menu-row-link"
  }, "Third-party integrations")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/protocols"),
    className: "ui-footer-menu-row-link"
  }, "Multiple protocol messaging")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full xs:col-span-3 md:col-span-1"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("h2", {
    className: "ui-footer-col-title"
  }, "Ably is for"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/asset-tracking"),
    className: "ui-footer-menu-row-link"
  }, "Ably Asset Tracking")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/extend-kafka-to-the-edge"),
    className: "ui-footer-menu-row-link"
  }, "Extend Kafka to the edge")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/edtech"),
    className: "ui-footer-menu-row-link"
  }, "EdTech")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/automotive-logistics-and-mobility"),
    className: "ui-footer-menu-row-link"
  }, "Automotive, Logistics, & Mobility")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/b2b-platforms"),
    className: "ui-footer-menu-row-link"
  }, "B2B Platforms")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/healthcare"),
    className: "ui-footer-menu-row-link"
  }, "Healthcare")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/ecommerce-and-retail"),
    className: "ui-footer-menu-row-link"
  }, "eCommerce & Retail")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/sports-and-media"),
    className: "ui-footer-menu-row-link"
  }, "Sports & Media")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/gaming"),
    className: "ui-footer-menu-row-link"
  }, "Gaming")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/solutions/iot-and-connected-devices"),
    className: "ui-footer-menu-row-link"
  }, "IoT & Connected Devices")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full xs:col-span-3 md:col-span-1"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("h2", {
    className: "ui-footer-col-title"
  }, "Developers"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/docs/quick-start-guide"),
    className: "ui-footer-menu-row-link"
  }, "Start in 5 minutes")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/docs/"),
    className: "ui-footer-menu-row-link"
  }, "Documentation")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/tutorials"),
    className: "ui-footer-menu-row-link"
  }, "Tutorials")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: "https://changelog.ably.com/",
    className: "ui-footer-menu-row-link"
  }, "Changelog")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/support"),
    className: "ui-footer-menu-row-link"
  }, "Support & FAQs")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/docs/sdks"),
    className: "ui-footer-menu-row-link"
  }, "SDKs")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug flex items-center -mt-4"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "pr-8 ui-footer-menu-row-link",
    href: "https://status.ably.com/"
  }, "System status"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("iframe", {
    className: "w-20 h-20 mb-2",
    src: "https://status.ably.com/embed/icon",
    allowTransparency: true,
    frameBorder: "0",
    scrolling: "no",
    title: "System Status"
  })))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full xs:col-span-3 md:col-span-1"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("h2", {
    className: "ui-footer-col-title"
  }, "WHY ABLY"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/customers"),
    className: "ui-footer-menu-row-link"
  }, "Customers")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/case-studies"),
    className: "ui-footer-menu-row-link"
  }, "Case Studies")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/four-pillars-of-dependability"),
    className: "ui-footer-menu-row-link"
  }, "Four Pillars of Dependability")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/compare"),
    className: "ui-footer-menu-row-link"
  }, "Compare our tech")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/protocols"),
    className: "ui-footer-menu-row-link"
  }, "Multi protocol support")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/integrations"),
    className: "ui-footer-menu-row-link"
  }, "Third-party integrations")))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full xs:col-span-3 md:col-span-1"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("h2", {
    className: "ui-footer-col-title"
  }, "ABOUT"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("ul", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/about"),
    className: "ui-footer-menu-row-link"
  }, "About Ably")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/pricing"),
    className: "ui-footer-menu-row-link"
  }, "Pricing")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/blog"),
    className: "ui-footer-menu-row-link"
  }, "Blog")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/careers"),
    className: "ui-footer-menu-row-link"
  }, "Careers")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/open-policy"),
    className: "ui-footer-menu-row-link"
  }, "Open protocol policy")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/press-center"),
    className: "ui-footer-menu-row-link"
  }, "Press & Media")), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("li", {
    className: "p-menu-row-snug"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/contact"),
    className: "ui-footer-menu-row-link"
  }, "Contact us"))))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "max-w-screen-xl ui-grid-px mx-auto"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("hr", {
    className: "border-t border-mid-grey my-0"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "max-w-screen-xl mx-auto py-16 grid ui-grid-gap ui-grid-px sm:grid-cols-2"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "md:flex md:items-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex flex-col md:flex-row flex-auto ml-8 sm:col-span-1 md:col-span-2"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: ""
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex pb-24"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "h-24 pr-24 text-cool-black hover:text-icon-twitter",
    href: "https://twitter.com/ablyrealtime",
    title: "Ably on X"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-social-x",
    size: "1.5rem"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "h-24 pr-24 text-cool-black hover:text-icon-linkedin",
    href: "https://www.linkedin.com/company/ably-realtime",
    title: "Ably on LinkedIn"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "linkedin",
    size: "1.5rem"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "h-24 pr-24 text-cool-black hover:text-icon-github",
    href: "https://github.com/ably/",
    title: "Ably on Github"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "github",
    size: "1.5rem"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "h-24 pr-24 text-cool-black hover:text-icon-discord",
    href: "https://discord.gg/jwBPhEZ9g5",
    title: "Ably on Discord"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "discord",
    size: "1.5rem"
  })))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "xs:hidden sm:block ui-footer-glassdoor"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex sm:pt-24 md:pt-0 sm:border-t sm:border-l-0 md:border-t-0 md:border-l sm:border-mid-grey sm:w-3/4 md:w-full md:pl-24"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: "https://www.glassdoor.co.uk/Overview/Working-at-Ably-EI_IE2184188.11,15.htm",
    className: "h-24 text-cool-black hover:text-icon-glassdoor",
    title: "Ably reviews on glassdoor"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "glassdoor",
    size: "1.5rem"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "pl-16 text-menu3 font-sans font-medium"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("strong", {
    className: "block font-medium"
  }, "We're hiring!"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: "https://www.glassdoor.co.uk/Overview/Working-at-Ably-EI_IE2184188.11,15.htm",
    className: "ui-footer-link"
  }, "Learn more at Glassdoor"))))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "xs:block sm:hidden"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "border-t border-mid-grey w-full"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex py-24"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    className: "h-24 pr-16 text-cool-black hover:text-icon-glassdoor",
    href: "https://www.glassdoor.co.uk/Overview/Working-at-Ably-EI_IE2184188.11,15.htm",
    title: "Ably reviews on glassdoor"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "glassdoor",
    size: "1.5rem"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "text-menu3 font-sans font-medium"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("strong", {
    className: "block font-medium"
  }, "We're hiring!"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: "https://www.glassdoor.co.uk/Overview/Working-at-Ably-EI_IE2184188.11,15.htm",
    className: "ui-footer-link"
  }, "Learn more at Glassdoor"))))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "col-span-full sm:col-span-1 inline-flex sm:ml-auto sm:items-center"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("img", {
    className: "mr-24 h-80",
    src: paths.highestUserAdoption,
    alt: "Highest User Adoption 2023"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("img", {
    className: "mr-24 h-80",
    src: paths.bestSupport,
    alt: "Best Support 2023"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("img", {
    className: "mr-24 h-80",
    src: paths.fastestImplementation,
    alt: "Fastest Implementation 2023"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("img", {
    className: "mr-24 h-80",
    src: paths.highestPerformer,
    alt: "High Performer 2023"
  }))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "max-w-screen-xl ui-grid-px mx-auto"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("hr", {
    className: "border-t border-mid-grey my-0"
  })), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "max-w-screen-xl mx-auto py-24 sm:py-40 md:py-32 md:grid md:grid-cols-2 ui-grid-gap ui-grid-px"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex ml-8 col-span-full sm:col-span-1 md:pb-16 items-center ui-footer-bottom-links"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/privacy"),
    className: "pr-24 ui-footer-link"
  }, "Cookies"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/legals"),
    className: "pr-24 ui-footer-link"
  }, "Legals"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/data-protection"),
    className: "pr-24 ui-footer-link"
  }, "Data Protection"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("a", {
    href: absUrl("/privacy"),
    className: "ui-footer-link"
  }, "Privacy"))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "xs:grid xs:grid-cols-2 sm:grid-cols-4 xs:pl-16 sm:pl-8 md:justify-items-end"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex mr-24"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-gui-tick",
    color: "text-active-orange",
    size: "1.5rem",
    additionalCSS: "bg-white rounded-full mr-12 ui-footer-tick-icon"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-bold whitespace-nowrap"
  }, "SOC 2 Type 2"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-medium mb-24"
  }, "Certified"))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex mr-24 md:col-start-2"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-gui-tick",
    color: "text-active-orange",
    size: "1.5rem",
    additionalCSS: "bg-white rounded-full mr-12 ui-footer-tick-icon"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-bold whitespace-nowrap"
  }, "HIPAA"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-medium mb-24"
  }, "Compliant"))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex mr-24 md:col-start-3"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-gui-tick",
    color: "text-active-orange",
    size: "1.5rem",
    additionalCSS: "bg-white rounded-full mr-12  ui-footer-tick-icon"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-bold whitespace-nowrap"
  }, "EU GDPR"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-medium mb-24"
  }, "Certified"))), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", {
    className: "flex mr-24 md:col-start-4"
  }, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement(component["default"], {
    name: "icon-gui-tick",
    color: "text-active-orange",
    size: "1.5rem",
    additionalCSS: "bg-white rounded-full mr-12  ui-footer-tick-icon"
  }), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("div", null, /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-bold whitespace-nowrap"
  }, "256-bit AES"), /*#__PURE__*/external_commonjs_react_commonjs2_react_default().createElement("p", {
    className: "ui-footer-compliance-text font-medium mb-24"
  }, "Encryption"))))));
}
Footer.propTypes = {
  paths: external_commonjs_prop_types_commonjs2_prop_types_default().shape({
    ablyStack: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
    highestPerformer: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
    highestUserAdoption: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
    bestSupport: (external_commonjs_prop_types_commonjs2_prop_types_default()).string,
    fastestImplementation: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
  }),
  urlBase: (external_commonjs_prop_types_commonjs2_prop_types_default()).string
};
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});